@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/link' as link;

leichte-sprache-bubble {
  display: block;
  width: 100%;
  height: 100%;

  section {
    padding: 1rem; // Has to adapt to global font size coming from BA CSS outside this component
    box-shadow: var.$message-screen-elements-box-shadow;
    box-sizing: border-box;

    a {
      &:link {
        color: var.$ls-link-color-unvisited;
      }

      &:visited {
        color: var.$ls-link-color-visited;
      }

      &:focus {
        outline: 3px solid var.$ls-focus-color;
        outline-offset: 2px;
        color: var.$ls-link-color-unvisited;
        &:visited {
          color: var.$ls-link-color-visited;
        }
      }

      &:hover {
        color: var.$ls-link-color-unvisited; // For IE11 and Edge, where the styles clash with BA CSS
      }

      &:active {
        color: var.$ls-link-color-unvisited;
      }
    }

    &.bot,
    &.loading {
      border-radius: var.$bubble-border-radius;
      background: var.$ls-bot-bubble;
      color: var.$ls-text-color-dark;
    }
    &.user {
      border-radius: 10px 10px 0 10px;
      background: var.$ls-user-bubble;
      color: var.$ls-text-color-dark;
    }
    &.loading {
      span {
        font-size: 2rem;
        line-height: 0;
        animation-name: blink;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
      }
      span:nth-child(2) {
        animation-delay: 0.2s;
      }
      span:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
